var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-warp"},[_c('div',{staticClass:"main",style:('background: url(' +
        _vm.detail.background_img +
        ') no-repeat top center #2d127d; background-size:100% auto;')},[_c('div',{staticClass:"title-warp",style:('width:' +
          680 * _vm.baseSize +
          'px;padding-top:' +
          0 +
          'px; margin-bottom:' +
          40 * _vm.baseSize +
          'px')},[_c('img',{attrs:{"src":_vm.detail.brief_img}})]),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.prizeForm)?_c('Form'):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"loading",on:{"touchmove":function($event){_vm.showLoading=false}}},[_c('Loading',{attrs:{"bgColor":"#0075ff","loading":_vm.showLoading}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-115f4129","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LuckDraw/Base.vue
// module id = null
// module chunks = 